"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var styled_components_1 = __importDefault(require("styled-components"));
var GridContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: flex-start;\n  width: 100%;\n  display: flex;\n  /* -webkit-flex needs to be after display:\n   flex; otherwise Tizen can't read -webkit-flex for some reason */\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n"], ["\n  align-items: flex-start;\n  width: 100%;\n  display: flex;\n  /* -webkit-flex needs to be after display:\n   flex; otherwise Tizen can't read -webkit-flex for some reason */\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n"])));
exports.default = GridContainer;
var templateObject_1;
//# sourceMappingURL=GridContainer.js.map